/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Formats_BodyInputs */

const en_mcp_cap_formats_body = /** @type {(inputs: Mcp_Cap_Formats_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your agent checks the supported formats and languages before it sends anything.`)
};

const es_mcp_cap_formats_body = /** @type {(inputs: Mcp_Cap_Formats_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu agente consulta los formatos y los idiomas compatibles antes de enviar nada.`)
};

/**
* | output |
* | --- |
* | "Your agent checks the supported formats and languages before it sends anything." |
*
* @param {Mcp_Cap_Formats_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_formats_body = /** @type {((inputs?: Mcp_Cap_Formats_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Formats_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_formats_body(inputs)
	return en_mcp_cap_formats_body(inputs)
});